// extracted by mini-css-extract-plugin
export default {"section":"TopBanner_section__cueqe","wrapper":"TopBanner_wrapper__gFnNp","shape":"TopBanner_shape__4VSa5"};